import React, { useState, useEffect } from "react";
import { FacebookEmbed, YouTubeEmbed } from "react-social-media-embed";

function VideoEmbed({ videoLink }) {
  const [embedType, setEmbedType] = useState("");
  const [embedCode, setEmbedCode] = useState("");
  const youtubeRegex =
    /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=|shorts\/)|youtu\.be\/)([\w\-]+)/;
  const facebookVideoRegex =
    /(?:https?:\/\/)?(?:www.|web.|m.)?(facebook|fb).(com|watch)\/(?:video.php\?v=\d+|(\S+)|photo.php\?v=\d+|\?v=\d+)|\S+\/videos\/((\S+)\/(\d+)|(\d+))\/?/;
  const facebookReelRegex =
    /(?:https?:\/\/)?(?:www\.)?facebook\.com\/(?:reel|watch)\/(\d+)/;

  const linkedInRegex =
    /(?:https?:\/\/)?(?:www\.)?linkedin\.com\/posts\/.*-activity-(\d+)/;
  const instagramRegex =
    /(?:https?:\/\/)?(?:www\.)?instagram\.com\/(?:p|reel|tv)\/([a-zA-Z0-9_-]+)/;

  useEffect(() => {
    if (videoLink) {
      handleSubmit();
    }
  }, []);

  const handleSubmit = (event) => {
    if (event) event.preventDefault();

    if (
      videoLink?.includes("https://fb") ||
      videoLink?.includes("facebook.com")
    ) {
      if (facebookReelRegex.test(videoLink)) {
        const match = videoLink.match(facebookReelRegex);
        const videoId = match[1];
        setEmbedCode(
          `<iframe 
          src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F${videoId}%2F&show_text=false&width=267&t=0" 
          width="267" 
          height="476" 
          style="border:none;overflow:hidden" 
          scrolling="no" 
          frameborder="0" 
          allowfullscreen="true" 
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" 
          allowFullScreen="true">
        </iframe>`
        );
        setEmbedType("facebookReel");
      } else if (facebookVideoRegex.test(videoLink)) {
        setEmbedType("facebookVideo");
      } else {
        setEmbedType("");
      }
    } else if (instagramRegex.test(videoLink)) {
      const match = videoLink.match(instagramRegex);
      const postId = match[1];
      setEmbedCode(
        `<iframe 
          src="https://www.instagram.com/p/${postId}/embed" 
          width="400" 
          height="480" 
          frameborder="0" 
          scrolling="no" 
          allowtransparency="true">
        </iframe>`
      );
      setEmbedType("instagram");
    } else if (youtubeRegex.test(videoLink)) {
      const match = videoLink.match(youtubeRegex);
      const videoId = match[1];
      if (videoLink.includes("/shorts/")) {
        setEmbedCode(
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/${videoId}"
            title="YouTube Video"
            frameborder="0"
            allowfullscreen
          ></iframe>
        );
      } else {
        setEmbedCode(
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/${videoId}?start=30"
            title="YouTube Video"
            frameborder="0"
            allowfullscreen
          ></iframe>
        );
      }
      setEmbedType("youtube");
    } else if (linkedInRegex.test(videoLink)) {
      const match = videoLink.match(linkedInRegex);
      const activityId = match[1];
      setEmbedCode(
        `<iframe src="https://www.linkedin.com/embed/feed/update/urn:li:activity:${activityId}" height="315" width="560" frameborder="0" allowfullscreen title="LinkedIn Video"></iframe>`
      );
      setEmbedType("linkedin");
    }
  };

  return (
    <div>
      <div className="video-embed-player">
        {embedType === "facebookVideo" && (
          <FacebookEmbed url={videoLink} width={"100%"} />
        )}
        {embedType === "facebookReel" && (
          <div dangerouslySetInnerHTML={{ __html: embedCode }} />
        )}
        {embedType === "instagram" && (
          <div dangerouslySetInnerHTML={{ __html: embedCode }} />
        )}
        {embedType === "youtube" && (
          <YouTubeEmbed url={videoLink} width={"100%"} />
        )}
        {embedType === "linkedin" && (
          <div dangerouslySetInnerHTML={{ __html: embedCode }} />
        )}
        {embedType === "" && (
          <p>
            Please paste a valid Facebook, Instagram, YouTube or LinkedIn video
            link.
          </p>
        )}
      </div>
    </div>
  );
}

export default VideoEmbed;
